import { VideoPlayer } from "ui";
export type PostMediaVidProps = {
    vid: string;
};

const PostMediaVid = ({ vid }: PostMediaVidProps) => {
    return (
        <div className="post-image">
            <VideoPlayer src={vid} />
        </div>
    );
};

export default PostMediaVid;
